/**
 * DateRangePresetSelect
 *
 * MUI TextField select that shows relative date-range options. Used in two
 * contexts:
 *   1. Scheduled HazardAI panel reports (SubscriptionReportItemUpsert) — uses
 *      default DATE_RANGE_PRESETS, resolved server-side at report-generation time.
 *   2. Live dashboard panels (e.g. HazardAITotalDetections) — pass
 *      presets={PANEL_DATE_RANGE_PRESETS} and size="small"; resolved client-side
 *      via resolveDateRangePreset().
 */

import {MenuItem, TextField} from '@mui/material';

import {DATE_RANGE_PRESETS, DateRangePreset} from '../../utils/dateRange';

interface DateRangePresetSelectProps {
  value: DateRangePreset | null;
  onChange: (value: DateRangePreset) => void;
  presets?: Array<{value: DateRangePreset; label: string}>;
  label?: string;
  helperText?: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
}

export const DateRangePresetSelect: React.FC<DateRangePresetSelectProps> = ({
  value,
  onChange,
  presets = DATE_RANGE_PRESETS,
  label = 'Date Range',
  helperText = 'The report will cover this window each time it runs.',
  fullWidth = true,
  size,
}) => {
  return (
    <TextField
      select
      fullWidth={fullWidth}
      label={label}
      value={value ?? ''}
      size={size}
      onChange={(e) => onChange(e.target.value as DateRangePreset)}
      helperText={helperText || undefined}
    >
      {presets.map((preset) => (
        <MenuItem key={preset.value} value={preset.value}>
          {preset.label}
        </MenuItem>
      ))}
    </TextField>
  );
};
